<ngx-loading [show]="isProcessing"></ngx-loading>

<section>
  <datalist id="listCentroCustos">
    <select>
      <option *ngFor="let item of centrosDeCusto" [value]="item.nome"></option>
    </select>
  </datalist>
</section>


<div class="row">
  <div class="col">
    <div class="box box-primary">

      <div class="box-header text-center pb-0 mb-0">
        <h3 class="box-title ">Consulta de OSs emitidas</h3><br />
      </div>
      <div class="divider"></div>
      <div class="box-body" style="height: 850px;">

        <form novalidate [formGroup]="form" id="form" (ngSubmit)="submit()">

          <div class="row">
            <div class="col-md-3" style="border-right: solid 1px #ddd;">

              <div class="col-md-12">
                <div class="form-group">
                  <label for="">Número <b>OS</b></label>
                  <div class="input-group">
                    <input type="text" class="form-control fs11" formControlName="oSId" id="oSId" digitOnly
                      maxlength="5">
                    <div class="input-group-append cp" title="Limpar campo">
                      <span class="input-group-text btn-light cp" (click)="clearNumeroOS()"><i
                          class="fa fa-times"></i></span>
                      <button type="button" class="input-group-text btn-primary cp" (click)="searchByKeys('os')"><i
                          class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="">OSs originais de <b>SS Nº</b></label>
                  <div class="input-group">
                    <input type="text" class="form-control fs11" formControlName="sSId" id="sSId" digitOnly
                      maxlength="5">
                    <div class="input-group-append cp" title="Limpar campo">
                      <span class="input-group-text btn-light cp" (click)="clearSSId()"><i
                          class="fa fa-times"></i></span>
                      <button type="button" class="input-group-text btn btn-primary cp" (click)="searchByKeys('ss')"><i
                          class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for="">OSs originais de <b>PT Nº</b></label>
                  <div class="input-group">
                    <input type="text" class="form-control fs11" formControlName="pTId" id="pTId" digitOnly
                      maxlength="5">
                    <div class="input-group-append cp" title="Limpar campo">
                      <span class="input-group-text btn-light cp" (click)="clearPTId()"><i
                          class="fa fa-times"></i></span>
                      <button type="button" class="input-group-text btn-primary cp" (click)="searchByKeys('pt')"><i
                          class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>



            </div>




            <div class="col-md-9">
              <div class="form-row" [hidden]="this.empreiteirasCB?.length == 1">

                <div class="col-md-4" [hidden]="this.empreiteirasCB?.length == 1">
                  <div class="position-relative form-group">
                    <label for="">Empreiteira</label>
                    <select class="form-control" formControlName="empreiteiraId">
                      <option value="" selected>Todas as Empreiteiras</option>
                      <option *ngFor="let t of empreiteirasCB" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="form-row">

                <div class="col-md-4">
                  <div class="form-group">
                    <label for="areaTecnicaId">Área Técnica</label>
                    <select class="form-control" formControlName="areaTecnicaId">
                      <option value="" selected>Todas as áreas técnicas</option>
                      <option *ngFor="let t of areasTecnicasCB" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="status">Situação/Status</label>
                    <select class="form-control" formControlName="status">
                      <option value="" selected>Todos os status</option>
                      <option value="1">Aberta</option>
                      <option value="2">Não Realizada</option>
                      <option value="3">Fechada</option>
                      <option value="4">Cancelada</option>
                      <option value="7">Reprovada</option>
                    </select>
                  </div>
                </div>



                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Tipo de OS</label>
                    <select class="form-control" formControlName="tipoOS">
                      <option value="">Todos os Tipos</option>
                      <option *ngFor="let op of this.tipoOSFixas" [value]="op.codigo">{{op.descricao}}</option>
                      <option *ngFor="let op of this.tipoOSAdicionais" [value]="op.codigo">{{op.descricao}}</option>
                      <option *ngFor="let op of this.tipoOSPreventivas" [value]="op.codigo">{{op.descricao}}</option>
                    </select>
                  </div>
                </div>

              </div>



              <div class="form-row">

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="">Grupo local</label>
                    <select for="" class="form-control" formControlName="grupoLocalNivel1Id"
                      (change)="changeGrupoLocalNivel1()">
                      <option value="">Todos Grupo local</option>
                      <option *ngFor="let t of this.niveis1" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>


                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Local de trabalho</label>
                    <select class="form-control" formControlName="localId"
                      (change)="getEquipamentoPorLocalId($event.target.value)">
                      <option value="" selected>Todos locais de trabalho</option>
                      <option *ngFor="let t of locaisCB" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Equipamento</label>
                    <select class="form-control" formControlName="equipamentoId">
                      <option value="" selected>Todos os equipamentos</option>
                      <option *ngFor="let t of equipamentos" [value]="t.id">{{ t.nome }}</option>
                    </select>
                  </div>
                </div>






              </div>

              <div class="form-row">

                <div class="col-md-4">
                  <div class="position-relative form-group">
                    <label for="status">Tipo de data</label>
                    <select class="form-control" formControlName="tipoDeData"
                      (change)="validaComboTipoDados($event.target.value)"
                      [ngClass]="{'h-error' : validacaoComboTipoDeData != ''}">
                      <option value="E" selected>Emissão</option>
                      <option value="R" selected>Execução</option>
                      <option value="F">Fechamento</option>
                      <option value="P">Data de previsão</option>
                    </select>
                    <span *ngIf="validacaoComboTipoDeData != ''"
                      class="text-danger">{{this.validacaoComboTipoDeData}}</span>
                  </div>
                </div>


                <div class="col-md-2">
                  <div class="form-group">
                    <label for="id">Data Inicial</label>
                    <input class="form-control" type="date" formControlName="dataInicial" max="2999-12-31"
                      [ngClass]="{'h-error' : validacaoDatas != ''}"
                      (change)="validaDatas(this.form.controls.dataInicial.value, this.form.controls.dataFinal.value)">
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="form-group">
                    <label for="requisitante">Data Final</label>
                    <input class="form-control" type="date" formControlName="dataFinal" max="2999-12-31"
                      [ngClass]="{'h-error' : validacaoDatas != ''}"
                      (change)="validaDatas(this.form.controls.dataInicial.value, this.form.controls.dataFinal.value)">
                    <span *ngIf="validacaoDatas!=''" class="text-danger">{{this.validacaoDatas}}</span>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Colaborador</label>
                    <select class="form-control" formControlName="colaboradorId">
                      <option value="" selected>Todos</option>
                      <option *ngFor="let u of funcionarios" value="{{ u.id }}">{{ u.nome }}</option>
                    </select>
                  </div>
                </div>


              </div>

              <div class="row">

                <div class="col-md-4">
                  <div class="form-group">
                    <label for="centroDeCusto">{{labelCentroCusto}}</label>
                    <div class="input-group">
                      <input type="text" class="form-control" list="listCentroCustos"
                        formControlName="centroCustoDescricao"
                        (change)="changeDataListCentroCustos($event.target.value)" maxlength="40" />
                      <div class="input-group-append cp" (click)="limparDataListCentroCustos()"
                        title="limpar campo e recarregar lista de opções">
                        <span class="input-group-text"><i class="fa fa-trash"></i></span>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="col-md-5">
                  <div class="form-group">
                    <label for="">Usuário solicitante</label>
                    <select class="form-control" formControlName="usuarioSolicitouId">
                      <option value="" selected>Todos</option>
                      <option *ngFor="let u of usuarios" value="{{ u.id }}">{{ u.nome }}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-2">
                  <button type="submit" class="btn btn-primary btn-block btn-bottom btn-shadow" form="form">
                    <i class="fa fa-search"></i></button>
                </div>

                <div class="col-md-1">
                  <button type="button" class="btn btn-light btn-block btn-bottom btn-shadow" (click)="reset()"><i
                      class="fa fa-trash"></i></button>
                </div>

              </div>

            </div>
          </div>



        </form>

        <section *ngIf="this.resultadosPesquisa?.length > 0" class="animated fadeInDown mt-2">

          <div class="box box-primary">

            <div class="box-header pb-0">
              <div class="row">
                <div class="col-md-12">
                  <div class="d-flex justify-content-center">
                    <h3 class="box-title ">Resultado da Pesquisa</h3><br />
                  </div>
                </div>
              </div>
            </div>

            <div class="box-body">

              <app-grid-OSs [listaDeOSs]="this.resultadosPesquisa" [podeImprimir]="this.autorizacoes?.podeListar"
                [heightGridPx]=300 [modoEdicao]=this.autorizacaoEditarOS>
              </app-grid-OSs>
            </div>
          </div>
        </section>

        <section *ngIf="this.resultadosPesquisa?.length ==  0 && nenhumResultado == true"
          class="animated fadeInDown h300 text-center" style="margin-top:70px;">

          <div class="row">
            <div class="col-md-12">
              <img src="./assets/images/no-result2.png">
            </div>
            <div class="col-md-12">
              <h6>Nenhum resultado foi encontrado</h6>
            </div>
            <div class="col-md-12">
              <h6>com os parâmetros fornecidos</h6>
            </div>
          </div>
        </section>

      </div>
    </div>
  </div>
</div>

<div class="row mb-3" *ngIf="excelFileName !== ''">
  <div class="col-md-4"></div>
  <div class="col-md-4 text-center" [class.highlight]="excelFileName !== ''">
    <a *ngIf="excelFileName !== ''" [href]="hrefExcelFile">{{excelFileName}}</a>

  </div>
  <div class="col-md-1">
    <span class="fa fa-trash cp" (click)="removeLinkExcel()"></span>
  </div>
</div>

<div class="row">
  <div class="col-md-12">
    <div class="box box-primary">
      <div class="box-body">
        <div class="form-row">
          <div class="col-md-1 mb-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>

          <div class="col-md-3">
            <button class="btn btn-primary btn-shadow btn-block" type="button" (click)="exportarToPdf()"
              [disabled]="(this.resultadosPesquisa == undefined || this.resultadosPesquisa?.length == 0) || this.isProcessing || !this.autorizacoes?.podeListar">
              <i class="fa fa-table pt-1 pull-left"></i>Listar OSs Emitidas
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-primary btn-shadow btn-block" type="button" (click)="exportarToExcel()"
              [disabled]="(this.resultadosPesquisa == undefined || this.resultadosPesquisa?.length == 0) || this.isProcessing || !this.autorizacoes?.podeListar">
              <i class="fa fa-table pt-1 pull-left"></i>Exportar OSs Emitidas
            </button>
          </div>

          <div class="col-md-3">
            <button class="btn btn-secondary btn-shadow btn-block mr-2" type="button" (click)="exportarMaterial()"
              [disabled]="(this.resultadosPesquisa == undefined || this.resultadosPesquisa?.length == 0) || this.isProcessing || !this.autorizacoes?.podeListar">
              <i class="fa fa-table pt-1 pull-left"></i>Exportar Mat. Aplicados
            </button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-light btn-shadow btn-block" type="button" (click)="exportarFuncionario()"
              title="Listar Colaboradores Atuantes"
              [disabled]="(this.resultadosPesquisa == undefined || this.resultadosPesquisa?.length == 0) || this.isProcessing || !this.autorizacoes?.podeListar">
              <i class="fa fa-print pt-1 pull-left"></i>L. Colab. Atuantes
            </button>
          </div>

        </div>


      </div>
    </div>
  </div>
</div>